import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Search, MapPin, ShieldCheck, FileText, CheckCircle, Star, ArrowRight } from 'lucide-react';
import { properties, districts } from '../data/mockData';
import { PropertyCard } from '../components/shared/PropertyCard';
export const Home = () => {
  const featuredProperties = properties.slice(0, 8);
  return <div className="flex flex-col" data-id="element-1667">
      {/* Hero Section */}
      <section className="relative -mt-[88px] pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-primary-900" data-id="element-1668">
        <div className="absolute inset-0 z-0" data-id="element-1669">
          <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&q=80&w=2000" alt="Luxury Real Estate" className="w-full h-full object-cover opacity-70" data-id="element-1670" />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 via-primary-900/50 to-primary-900/20" data-id="element-1671" />
        </div>

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-1672">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-1673">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="max-w-2xl" data-id="element-1674">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20 text-white text-sm font-medium mb-6 backdrop-blur-md" data-id="element-1675">
                <ShieldCheck size={16} className="text-secondary" data-id="element-1676" />
                AGIS/FCDA Verified Listings
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-tight mb-6" data-id="element-1677">
                Verified Abuja Properties for Sale.{' '}
                <span className="text-secondary" data-id="element-1678">No Middle Man</span>
              </h1>
              <p className="text-lg text-neutral-300 mb-8 leading-relaxed max-w-xl" data-id="element-1679">
                Discover verified land and property listings directly from
                trusted owners and authorized sellers. Secure, transparent, and
                premium.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-1680">
                <Link to="/explore" className="bg-secondary hover:bg-secondary-dark text-white px-8 py-4 rounded-xl font-semibold text-center transition-colors shadow-glow flex items-center justify-center gap-2" data-id="element-1681">
                  Explore Properties <ArrowRight size={18} data-id="element-1682" />
                </Link>
                <Link to="/list-property" className="bg-white/10 hover:bg-white/20 text-white border border-white/20 px-8 py-4 rounded-xl font-semibold text-center transition-colors backdrop-blur-md" data-id="element-1683">
                  List Your Property
                </Link>
              </div>
            </motion.div>

            {/* Hero Map Mockup */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="hidden lg:block relative h-[500px] rounded-2xl overflow-hidden glass border-white/10 shadow-2xl" data-id="element-1684">
              <img src="https://images.unsplash.com/photo-1524661135-423995f22d0b?auto=format&fit=crop&q=80&w=1000" alt="Map View" className="w-full h-full object-cover opacity-80" data-id="element-1685" />
              {/* Floating Cards */}
              <div className="absolute top-10 left-10 bg-white p-3 rounded-xl shadow-xl flex gap-3 items-center animate-bounce" style={{
              animationDuration: '3s'
            }} data-id="element-1686">
                <img src={properties[0].images[0]} className="w-12 h-12 rounded-lg object-cover" data-id="element-1687" />
                <div data-id="element-1688">
                  <div className="text-xs font-bold text-primary-900" data-id="element-1689">
                    Maitama
                  </div>
                  <div className="text-xs text-text-light" data-id="element-1690">₦450M</div>
                </div>
              </div>
              <div className="absolute bottom-20 right-10 bg-white p-3 rounded-xl shadow-xl flex gap-3 items-center animate-bounce" style={{
              animationDuration: '4s',
              animationDelay: '1s'
            }} data-id="element-1691">
                <img src={properties[2].images[0]} className="w-12 h-12 rounded-lg object-cover" data-id="element-1692" />
                <div data-id="element-1693">
                  <div className="text-xs font-bold text-primary-900" data-id="element-1694">Jabi</div>
                  <div className="text-xs text-text-light" data-id="element-1695">₦180M</div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Search Bar Section */}
      <section className="relative z-20 -mt-10 container mx-auto px-4 md:px-6" data-id="element-1696">
        <div className="bg-white rounded-2xl shadow-xl p-4 md:p-6 border border-neutral-200" data-id="element-1697">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end" data-id="element-1698">
            <div data-id="element-1699">
              <label className="block text-xs font-bold text-text-light uppercase tracking-wider mb-2" data-id="element-1700">
                District
              </label>
              <div className="relative" data-id="element-1701">
                <MapPin size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-dark" data-id="element-1702" />
                <select className="w-full pl-10 pr-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:ring-2 focus:ring-secondary focus:border-secondary outline-none appearance-none" data-id="element-1703">
                  <option value="" data-id="element-1704">All Districts</option>
                  {districts.map(d => <option key={d.id} value={d.name} data-id="element-1705">
                      {d.name}
                    </option>)}
                </select>
              </div>
            </div>
            <div data-id="element-1706">
              <label className="block text-xs font-bold text-text-light uppercase tracking-wider mb-2" data-id="element-1707">
                Property Type
              </label>
              <select className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:ring-2 focus:ring-secondary focus:border-secondary outline-none appearance-none" data-id="element-1708">
                <option value="" data-id="element-1709">Any Type</option>
                <option value="house" data-id="element-1710">House</option>
                <option value="land" data-id="element-1711">Land</option>
                <option value="apartment" data-id="element-1712">Apartment</option>
              </select>
            </div>
            <div data-id="element-1713">
              <label className="block text-xs font-bold text-text-light uppercase tracking-wider mb-2" data-id="element-1714">
                Max Price
              </label>
              <select className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:ring-2 focus:ring-secondary focus:border-secondary outline-none appearance-none" data-id="element-1715">
                <option value="" data-id="element-1716">Any Price</option>
                <option value="100000000" data-id="element-1717">Up to ₦100M</option>
                <option value="500000000" data-id="element-1718">Up to ₦500M</option>
                <option value="1000000000" data-id="element-1719">Up to ₦1B</option>
              </select>
            </div>
            <button className="w-full bg-primary-900 hover:bg-primary-800 text-white py-3 rounded-xl font-semibold transition-colors flex items-center justify-center gap-2 h-[46px]" data-id="element-1720">
              <Search size={18} data-id="element-1721" /> Search
            </button>
          </div>
        </div>
      </section>

      {/* Featured Listings */}
      <section className="py-20 bg-neutral-light" data-id="element-1722">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1723">
          <div className="flex justify-between items-end mb-10" data-id="element-1724">
            <div data-id="element-1725">
              <h2 className="text-3xl font-serif font-bold text-primary-900 mb-2" data-id="element-1726">
                Featured Verified Listings
              </h2>
              <p className="text-text-light" data-id="element-1727">
                Premium properties vetted for authenticity.
              </p>
            </div>
            <Link to="/explore" className="hidden md:flex items-center gap-2 text-primary-900 font-semibold hover:text-secondary transition-colors" data-id="element-1728">
              View All <ArrowRight size={16} data-id="element-1729" />
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1730">
            {featuredProperties.map((property, index) => <motion.div key={property.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-1731">
                <PropertyCard property={property} data-id="element-1732" />
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Why AMU */}
      <section className="py-20 bg-white" data-id="element-1733">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1734">
          <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-1735">
            <h2 className="text-3xl font-serif font-bold text-primary-900 mb-4" data-id="element-1736">
              Why Choose AMU?
            </h2>
            <p className="text-text-light" data-id="element-1737">
              We are redefining real estate transactions in Abuja by removing
              informal agents and prioritizing trust.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-10" data-id="element-1738">
            {[{
            icon: ShieldCheck,
            title: 'Verified Listings',
            desc: 'Every property goes through rigorous AGIS/FCDA documentation checks before being listed.'
          }, {
            icon: FileText,
            title: 'Transparent Documentation',
            desc: 'Access verified title documents, C of O, and ownership history directly on the platform.'
          }, {
            icon: CheckCircle,
            title: 'Secure Discovery',
            desc: 'Connect directly with verified owners and authorized real estate companies. No hidden fees.'
          }].map((feature, i) => <div key={i} className="text-center p-6 rounded-2xl bg-neutral-50 border border-neutral-100 hover:shadow-lg transition-shadow" data-id="element-1739">
                <div className="w-16 h-16 mx-auto bg-primary-50 text-primary-900 rounded-2xl flex items-center justify-center mb-6" data-id="element-1740">
                  <feature.icon size={32} data-id="element-1741" />
                </div>
                <h3 className="text-xl font-serif font-bold text-primary-900 mb-3" data-id="element-1742">
                  {feature.title}
                </h3>
                <p className="text-text-light leading-relaxed" data-id="element-1743">
                  {feature.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Verification Process */}
      <section className="py-20 bg-primary-900 text-white" data-id="element-1744">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1745">
          <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-1746">
            <h2 className="text-3xl font-serif font-bold mb-4" data-id="element-1747">
              Our Verification Process
            </h2>
            <p className="text-neutral-300" data-id="element-1748">
              How we ensure every listing on AMU is 100% authentic and secure.
            </p>
          </div>

          <div className="relative" data-id="element-1749">
            <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-white/20 -translate-y-1/2 z-0" data-id="element-1750" />
            <div className="grid grid-cols-1 md:grid-cols-5 gap-8 relative z-10" data-id="element-1751">
              {[{
              step: '01',
              title: 'Seller Registration',
              desc: 'Identity verification'
            }, {
              step: '02',
              title: 'Document Upload',
              desc: 'Title & ownership docs'
            }, {
              step: '03',
              title: 'AGIS/FCDA Check',
              desc: 'Official verification'
            }, {
              step: '04',
              title: 'Listing Approval',
              desc: 'Quality assurance'
            }, {
              step: '05',
              title: 'Market Visibility',
              desc: 'Live on platform'
            }].map((step, i) => <div key={i} className="text-center" data-id="element-1752">
                  <div className="w-12 h-12 mx-auto bg-secondary text-white rounded-full flex items-center justify-center font-bold text-lg mb-4 shadow-glow relative" data-id="element-1753">
                    {step.step}
                  </div>
                  <h4 className="font-serif font-bold mb-2" data-id="element-1754">{step.title}</h4>
                  <p className="text-sm text-neutral-400" data-id="element-1755">{step.desc}</p>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Tiers */}
      <section className="py-20 bg-neutral-light" data-id="element-1756">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1757">
          <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-1758">
            <h2 className="text-3xl font-serif font-bold text-primary-900 mb-4" data-id="element-1759">
              Abuja Property Tiers
            </h2>
            <p className="text-text-light" data-id="element-1760">
              We categorize properties based on location to help you find
              exactly what you're looking for.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-1761">
            {[{
            tier: 'Tier 1',
            locations: 'Maitama, Asokoro, Wuse 2, CBD',
            desc: 'Premium luxury districts',
            bg: 'bg-secondary',
            text: 'text-white'
          }, {
            tier: 'Tier 2',
            locations: 'Gwarinpa, Jabi, Wuse, Garki',
            desc: 'High-demand urban centers',
            bg: 'bg-primary-900',
            text: 'text-white'
          }, {
            tier: 'Tier 3',
            locations: 'Lugbe, Kubwa, Lokogoma',
            desc: 'Developing residential areas',
            bg: 'bg-white',
            text: 'text-primary-900 border border-neutral-200'
          }].map((t, i) => <div key={i} className={`p-8 rounded-2xl shadow-soft ${t.bg} ${t.text}`} data-id="element-1762">
                <h3 className="text-2xl font-serif font-bold mb-2" data-id="element-1763">{t.tier}</h3>
                <p className="font-medium mb-4 opacity-90" data-id="element-1764">{t.locations}</p>
                <p className="text-sm opacity-80 mb-6" data-id="element-1765">{t.desc}</p>
                <Link to={`/explore?tier=${i + 1}`} className="inline-flex items-center gap-2 text-sm font-bold hover:opacity-80 transition-opacity" data-id="element-1766">
                  Explore Tier <ArrowRight size={16} data-id="element-1767" />
                </Link>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
};